<template>
  <div class="">
    <div class="overflow-y-hidden" style="height:200px" v-if="infoLoading" v-loading="true"></div>
    <div class="overflow-y-hidden" v-if="!infoLoading" >
        <p class="mb-1 text-medium-s text-theme-black-450 leading-22 font-normal">数据源</p>
      <div class="mb-3 text-medium-s text-theme-black-850 leading-22 font-normal">{{cellsData.sourceSurveyTitle}}</div>
      <p class=" mb-1 text-medium-s text-theme-black-450 leading-22 font-normal">数据范围</p>
      <div v-if="cellsData.filter.isComplexFilter" class="flex items-center">
        <p style="width:57px;white-space: nowrap;" class="mr-2 text-medium-s text-theme-black-850 leading-22 font-normal">数据字段</p>
        <condition-wrapper :disabled="true">
          <condition-container
            :condition="condition"
            :question-list="questionList"
            :show-survey-list="true"
            :survey-list="surveyList"
            :option="{ isEdit: false}"
          />
        </condition-wrapper>
      </div>
      <!-- 匹配选项 -->
      <div v-else class="flex items-center mb-3">
        <p style="width:57px;white-space: nowrap;" class="mr-2 text-medium-s text-theme-black-850 leading-22 font-normal">数据字段</p>
         <el-select class="mr-2" v-model="simpleFilter.surveyId" :disabled="true" placeholder="请选择">
          <el-option
            v-for="s of surveyList"
            :key="s.id"
            :label="s.name"
            :value="s.id">
          </el-option>
        </el-select>
        <el-select class="mr-2"  v-model="simpleFilter.questionId" :disabled="true">
          <el-option
            v-for="q of questionList"
            :key="q.id"
            :label="q.content.text"
            :value="q.id">
          </el-option>
        </el-select>
        <el-select v-model="simpleFilter.optionIds" :disabled="true">
          <el-option
            v-for="o of optionList"
            :key="o.id"
            :label="o.content.text"
            :value="o.id">
          </el-option>
        </el-select>
      </div>

    <!-- 计算公式 -->
        <p class="mb-1 text-medium-s text-theme-black-450 leading-22 font-normal">计算公式</p>
        <div v-if="cellsData.formula.isComplexFormula" class="flex items-center mb-3">
          <div style="width:57px;white-space: nowrap;" class=" mr-2 text-medium-s text-theme-black-850 leading-22 font-normal">表达式</div>
          <div style="background-color: #f5f7fa;color: #c4c7cf">
            <complex-calculation :timeSurveyId="cellsData.sourceSurveyId" :contenteditable="false" :initialValue.sync="cellsData.formula.complexFormulaHtml" :initialValueText.sync="cellsData.formula.complexFormulaText"></complex-calculation>
          </div>
        </div>
        <div v-else>
          <div class="flex mb-3 items-center">
            <p style="width:57px;white-space: nowrap;" class=" mr-2 text-medium-s text-theme-black-850 leading-22 font-normal">数据字段</p>
             <el-select class="mr-2"  v-model="simpleFormula.questionId" :disabled="true">
               <el-option
                 v-for="q of timeQuestionList"
                 :key="q.id"
                 :label="q.content.text"
                 :value="q.id">
               </el-option>
             </el-select>
             <el-select v-if="simpleFormula.questionType!=2 && simpleFormula.questionType!=7" v-model="simpleFormula.optionIds" :disabled="true">
               <el-option
                 v-for="o of timeOptionList"
                 :key="o.id"
                 :label="o.content.text"
                 :value="o.id">
               </el-option>
             </el-select>
             <el-select multiple v-if="simpleFormula.questionType==2 && simpleFormula.questionType!=7" v-model="simpleFormula.optionIds" :disabled="true">
               <el-option
                 v-for="o of timeOptionList"
                 :key="o.id"
                 :label="o.content.text"
                 :value="o.id">
               </el-option>
             </el-select>
          </div>
          <div class="flex items-center mb-3">
            <p style="width:57px;white-space: nowrap;" class="mr-2 text-medium-s text-theme-black-850 leading-22 font-normal">计算方式</p>
            <el-select v-model="cellsData.formula.simpleFormula.funcName" placeholder="请选择" :disabled="true">
              <el-option
                v-for="q of alculationMode(cellsData.formula.simpleFormula.questionType)"
                :key="q.value"
                :label="q.name"
                :value="q.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 指标数据预览 -->
        <preview-calcul :id="id" calculType="look" :calcResultTable="cellsData.calcResultTable" :indicatorDimensionIds="[cellsData.indicatorDimensionId]" :timeDimensionIds="[cellsData.timeDimensionId]"></preview-calcul>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import GlobalConfig from '@/global/config'
import ConditionWrapper from '@/condition/ConditionWrapper'
import ConditionContainer from '@/condition/ConditionContainer'
import { mapGetters } from 'vuex'
import { convertQuestionList } from '@/question/factory'
import {getCellSettingInfo} from '@/api/index-statistics'
import {getSurveyPreview } from '@/api/wenjuan/wjquestion'
import ComplexCalculation from './ComplexCalculation.vue'
import SelectList from './selectList.vue'
import PreviewCalcul from './PreviewCalculData.vue'

export default {
  name: 'CellInfo',
  components: {ConditionWrapper,ConditionContainer,ComplexCalculation,SelectList,PreviewCalcul},
  data() {
    return {
        condition: {
        matchMethod: 0,
        conditions: [
          {
            id: 1,
            leftValueType: 0,
            mainCode: null,
            mainQuestionType: null,
            mainType: null,
            operator: '',
            rightOptions: [],
            subCode: null,
            surveyId:null,
          }
        ]
      },
      questionList:[],
      optionList:[],
      timeQuestionList:[],
      timeOptionList:[],
      cellsData:{},
      simpleFilter:{},
      simpleFormula:{},
      infoLoading:true,
      complexsurveyList:[]
    }
  },
  props: {
    id:{
      type:Number,
      default:0
    },
    visiable:{
      type:Boolean,
      default:false
    }
  },
  watch: {
    // visiable(val){
    //     console.log(val,'0000')
    //     if(val){
    //       this.getCellData()
    //     }
    // },
    id(val){
        console.log('val,000')
        if(val){
          this.getCellData()
        }
    }
  },
computed:{
    ...mapGetters(['indexStatInfo','indexSurveyInfoList']),
    surveyList(){
        let surveyList =[]
        if(this.indexStatInfo && this.indexStatInfo.surveyId){
          const indexObj={id:this.indexStatInfo.surveyId,name:this.indexStatInfo.surveyName,isSample:this.indexStatInfo.isSample}
          surveyList.push(indexObj)
        }
        if(this.cellsData.sourceSurveyId==this.indexStatInfo.surveyId){
          return surveyList
        }
        const obj={id:this.cellsData.sourceSurveyId,name:this.cellsData.sourceSurveyTitle,isSample:false,}
        if(obj.id){
          surveyList.push(obj)
        }
        return surveyList
    },
},
  created(){
  },
  mounted(){
    this.getCellData()
  },
  methods:{
    getCellData(){
        this.infoLoading=true
      getCellSettingInfo({id:String(this.id)}).then(async res=>{
        if(res.data.code==0){
          let cellsData=res.data.data
          this.cellsData=cellsData
          if(cellsData.formula?.simpleFormula){
            this.simpleFormula=cellsData.formula.simpleFormula
            if(this.simpleFormula.optionIds && this.simpleFormula.questionType!=2){
              this.simpleFormula.optionIds=this.simpleFormula.optionIds.join(',')
            }
            await this.handleQuestionList(cellsData.sourceSurveyId,'timeQuestionList','timeOptionList',cellsData.formula.simpleFormula.questionId)
          }
          if(cellsData.filter?.complexFilter){
            // await this.initSurveyList()
            this.condition=cellsData.filter?.complexFilter
          }
          if(cellsData.filter?.simpleFilter){  
            this.simpleFilter=cellsData.filter.simpleFilter
            this.simpleFilter.optionIds=this.simpleFilter.optionIds.join(',')
            await this.handleQuestionList(cellsData.filter.simpleFilter.surveyId,'questionList','optionList',cellsData.filter.simpleFilter.questionId)
          }
          this.infoLoading=false

        }
      })
    },
   async handleQuestionList(surveyId,key,key2,questionId){
      let list=this.indexSurveyInfoList[surveyId]
       if(!list){
        await getSurveyPreview(surveyId).then(res=>{
           const { code, data } = res.data
           if (code === 0) {
             let qlist=data?.pageQuestions || []
             qlist = convertQuestionList(qlist)
             this.$store.commit('SET_INDEX_SURVRY_INFO_LIST',Object.assign(this.indexSurveyInfoList || {},{[surveyId]:qlist}))
             this[key] = qlist
           }else{
             this[key] = []
           }
           this[key2]=this.handleOptionList(this[key],questionId)
         })
       }else{
         this[key]=list
         this[key2]=this.handleOptionList(this[key],questionId)
       }
    },
    // async initQuestionList(surveyId){
    //   let list=this.indexSurveyInfoList[surveyId]
    //    if(!list){
    //     await getSurveyPreview(surveyId).then(res=>{
    //        const { code, data } = res.data
    //        if (code === 0) {
    //          let qlist=data?.pageQuestions || []
    //          qlist = convertQuestionList(qlist)
    //          this.$store.commit('SET_INDEX_SURVRY_INFO_LIST',Object.assign(this.indexSurveyInfoList || {},{[surveyId]:qlist}))
    //         return qlist
    //        }else{
    //         return []
    //        }
    //      })
    //    }else{
    //      return list
    //    }
    // },
     handleOptionList(list,q){
        let ques=list.find(val=>val.id==q)
        return ques.issue.items
     },
     alculationMode(type){
      if(type==7){
        return[{value:'SUM',name:'求和'},{value:'AVERAGE',name:'平均值'}]
      }else{
        return[{value:'COUNT',name:'计数'}]
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
